import styled from "styled-components";
import theme from "../../../styles/theme";

export const Container = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  font-family: var(--font-sans);
  margin-right: auto;
  margin-left: 7vw;
  margin-top: 3vh;

  .texts {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
  }
  .actions {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
  }
  .title {
    font-size: ${theme.fontSize.md};
    font-weight: 600;
    color: black;
  }
  .sub-title {
    font-size: ${theme.fontSize.mm};
    font-weight: 400;
    color: #5f6368;
  }

  /* Shell do admin (redesign V3): h1 de 32px, peso 400, alinhado ao conteúdo. */
  body[data-admin-shell] & {
    width: calc(100% - 64px);
    margin: 28px 32px 0;
    .title {
      font-size: 32px;
      line-height: 40px;
      font-weight: 400;
      color: var(--ink);
      letter-spacing: 0;
    }
    .sub-title {
      font-size: 14px;
      line-height: 20px;
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
`;
